import React from 'react';
import lodash from "lodash";
import Services from './../services/services';
import Breadcrumb from './../basics/Breadcrumb';
import ShopHeader from './ShopHeader';
import Notification from './../basics/Notification';

import {
  BrowserRouter as Router, Route, Routes, Link
} from "react-router-dom";

import { useEffect, useState } from 'react';
import { useParams, useNavigate } from "react-router-dom";

const Cart = () => {

  const services = new Services();

  let id: any = localStorage.getItem('orderId');

  const [checkout, setCheckout] = useState<string>('disabled');

  const [checkoutState, setCheckoutState] = useState<string>('Vyplňte údaje všech letenek');

  const navigate = useNavigate();

  const [products, setProducts] = useState<any[]>([]);

  const [notification, setNotification] = useState<any>();

  const [checkoutButton, setCheckoutButton] = useState(<button className={ "btn btn-lg rounded-pill btn-primary w-100 my-3 disabled " + checkout } onClick={() => handleCheckout()} >Přejít k pokladně</button>);

  const [lastProducts, setLastProducts] = useState<any[]>([]);

  let price: number = 0;

  useEffect(()=>{
    services.getCart(id).then( (value: any) => {
      setProducts(value.items)
      console.log('produkty')
      console.log(value.items)
    })
  }, [])

  useEffect(()=>{

    if(products.length > 0){

      let filled = true;

      products.forEach((item: any) =>{
        if( item.firstname == null || item.lastname == null){
          filled = false;
        }
      })

      if(!filled){
        setCheckout('disabled')
      }else{
        setCheckout('')

        setCheckoutState('Letenky jsou připraveny k nákupu')
      }

    }else{

      setCheckout('disabled')

    }

  }, [products])

  const cartItems: any[] = [];

  products.forEach((data: any, index: any) => {

    let imageLink:any = '';
    let itemPlace:any = '';
    let firstname_message:any = '';
    let lastname_message:any = '';

    if( data.product.attachment.length > 0){

      imageLink = <div className="img-container-1-1 img-container custom-radius"><img className="card-img-top" src={ 'http://api-balony.techcrowd.cz/' + data.product.attachment[0].path } /></div>;

    }

    if( data.place !== null){

      itemPlace = <div>{data.place.name}</div>;

    }

    if( data.productPrice !== null){

      price = +data.productPrice + price ;

    }

    if( data.firstname == null ){ firstname_message = 'Vyplňte jméno' }
    if( data.lastname == null ){ lastname_message = 'Vyplňte příjmení' }

    cartItems.push(
      <div className='row my-4' id={data.id}>

        <div className="col-12 col-lg-2">
          {imageLink}
        </div>

        <div className="col-12 col-lg-8 ps-5 d-flex flex-column justify-content-between">
          <strong className="text-primary">{data.product.price} kč</strong>
          <div className="fs-2"><Link className=" text-dark text-decoration-none" to={ "/product-detail/"+data.product.id } >{data.product.name}</Link></div>
          <div className="d-flex flex-row">Místo odletu: {itemPlace}</div>
          <form className="row mt-2">
          <div className="col-6">
            <input className="form-control" name="firstname" onChange={(e) => { debounce(data.id, e.target.name, e.target.value, index) }} onBlur={(e) => { onEdit(data.id, e.target.name, e.target.value, index ) }} type="text" placeholder={data.firstname || 'Jméno pasažéra'} aria-label=".form-control-lg example" />
            <small className="text-primary">{firstname_message}</small>
          </div>
          <div className="col-6">
            <input className="form-control" name="lastname" onChange={(e) => { debounce(data.id, e.target.name, e.target.value, index ) }} onBlur={(e) => { onEdit(data.id, e.target.name, e.target.value, index ) }} type="text" placeholder={data.lastname || 'Příjmení pasažéra'} aria-label=".form-control-lg example" />
            <small className="text-primary">{lastname_message}</small>
          </div>
          </form>
        </div>
        <div className="col-12 col-lg-2">
          <div className="float-end" onClick={() => { onDelete(data.id,data.product.name) }}><i className="text-muted fs-3 fa-solid fa-xmark"></i></div>
        </div>
        <hr className="mt-4" />
      </div>
    )
  })

  const onDelete = (id: any, name: any) => {

    console.log('test');
    console.log(id);

    let orderId: any = localStorage.getItem('orderId');

      services.dropCartItem(id).then( (value: any) => {

    });

    const newProducts = products.filter((item) => item.id !== id);

    setProducts(newProducts)

    setNotification(<Notification text={ "Produkt \""+name+"\" byl odstraněn z košíku"}/>)

  }

  const onEdit = (itemId: any, key: string, value: any, index: any) => {

    let change = {
      firstname: products[index].firstname,
      lastname: products[index].lastname,
      weight: products[index].weight,
      isPrint: products[index].isPrint
    }

    if( key == 'firstname' ){ change.firstname = value; products[index].firstname = value; }
    if( key == 'lastname' ){ change.lastname = value; products[index].lastname = value; }

    console.log(change);

    services.updateCartItem(id, itemId, change).then( (value: any) => {

      setProducts(value.data.items)

      console.log('LastProducts: ');

      console.log(value.data.items)

    })

  }

  let handleCheckout = () => {

    if( products.length > 0 ){

      navigate('/checkout',{state:{}});

    }

  }

  const debounce = lodash.debounce(onEdit, 1000)

  const breadcrumbs = [

    {'name':'Obchod', 'link':'/', 'active': true},
    {'name':'Košík','link': '/cart', 'active': false},

  ];

  return (
    <div className="mb-5">

      <ShopHeader title="Košík" subtitle="Košík subtitle" image="https://balloonadventures.cz/wp-content/uploads/2019/07/IMG_0581.jpg"/>

      <div className="container pb-2">

        {notification}

        <Breadcrumb links={breadcrumbs} />

        <div className="row">

          <div className="col-8">

            <div className="card border-0 custom-radius custom-shadow px-4 py-4">
              <div className="card-body d-flex flex-column justify-content-between">
                <div className="fs-4 text-primary"><strong>Můj košík</strong></div>
                <div>{cartItems}</div>
              </div>
            </div>

          </div>

          <div className="col-4">

          <div className="card border-0 custom-radius custom-shadow px-3 py-4">
            <div className="card-body d-flex flex-column justify-content-between">
              <div className="text-primary">{checkoutState}</div>
              <hr />
              <div className="fs-4 d-flex justify-content-between"><strong className="text-primary">Cena celkem </strong><strong>{price}</strong></div>

              <button className={ "btn btn-lg rounded-pill btn-primary w-100 my-3 " + checkout } onClick={() => handleCheckout()} >Přejít k pokladně</button>
              <div className="text-muted">Přijímané platby</div>

              </div>
            </div>

          </div>

        </div>

      </div>

    </div>
  );

}

export default Cart;
